import {createStyles} from '@mantine/core';
import React from 'react';

import {ReviewStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import Header, {type BadgeInfo} from 'ui-library/headers/Header';

const REVIEW_STATUS_TO_BADGE: Partial<Record<ReviewStatus, BadgeInfo>> = {
  [ReviewStatus.NEEDS_REVIEW]: {text: 'In review', color: 'blue', icon: 'clipboard-list'},
  [ReviewStatus.ACCEPTED]: {text: 'Accepted', color: 'green', icon: 'file-circle-check'},
  [ReviewStatus.REJECTED]: {text: 'Rejected', color: 'red', icon: 'user-pen'},
};

export interface EntryTemplateHeaderProps {
  allowEdits: boolean;
  collectionName?: string;
  onTitleChange: (newTitle: string) => Promise<void>;
  name: string;
  reviewStatus?: ReviewStatus;
}

/** Document-level header for an open entry template, rendered above the buffer tab strip. */
export default function EntryTemplateHeader({
  allowEdits,
  collectionName,
  onTitleChange,
  name,
  reviewStatus,
}: EntryTemplateHeaderProps): JSX.Element {
  const {classes} = useStyles();

  const badge = reviewStatus != null ? REVIEW_STATUS_TO_BADGE[reviewStatus] : undefined;

  return (
    <Header
      title={name}
      icon="file-in-brackets"
      iconColor="blue"
      crumbs={collectionName != null ? [{label: collectionName}] : []}
      badges={badge != null ? [badge] : []}
      isLocked={!allowEdits}
      onTitleChange={allowEdits ? onTitleChange : undefined}
      classNames={{body: classes.body}}
      dataTestAttrs={{component: 'EntryTemplateHeader', element: 'root'}}
    />
  );
}

const useStyles = createStyles(() => ({
  body: {boxShadow: 'none'},
}));
